import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/docs/privacy/PrivacyView.tsx");
